import _ from 'lodash';
export function  getApprovalListDataModel(apiResponse) {
    let listInfo = [];

    _.each(apiResponse,function (element) {
        let listObjDto = {
            "id" : "",
            "name" : "",
            "description" : ""
        };
        if(element && element !== ''){
            listObjDto.id=element;
            listInfo.push(listObjDto)
        }
    });
    return listInfo;
}